import axiosInstance from "../axiosInstance";

// Get athlete points for a specific user (admin only)
export const getAdminUserAthletePointsAPI = async (userId) => {
  try {
    const response = await axiosInstance.get(`/athletePoints/user/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update athlete points for a specific user (admin only)
export const updateAdminUserAthletePointsAPI = async (userId, updateData) => {
  try {
    const response = await axiosInstance.put(
      `/athletePoints/user/${userId}`,
      updateData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
